import { render } from "./IconExpandMore.vue?vue&type=template&id=61f2990c"
import script from "./IconExpandMore.vue?vue&type=script&lang=js"
export * from "./IconExpandMore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__